import type { PropsWithChildren } from 'react';

type BlogArticleDescriptionProps = PropsWithChildren;

export const BlogArticleDescription = ( { children }: BlogArticleDescriptionProps ) => {

  return (
    <p className={ 'font-inter text-sm text-[#ABB0C7] line-clamp-2' }>
      { children }
    </p>
  )
}
BlogArticleDescription.displayName = 'BlogArticleDescription';
